'use client';

import { useState, useEffect } from 'react';
import { LiveChat } from '../ui/design-system';

export default function LiveChatWrapper() {
  const [colorScheme, setColorScheme] = useState<'light' | 'dark' | 'system'>('light');
  const [mounted, setMounted] = useState(false);
  
  // Detect color scheme changes
  useEffect(() => {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
      setMounted(true);
      
      // Get initial color scheme
      const isDarkMode = document.documentElement.classList.contains('dark');
      setColorScheme(isDarkMode ? 'dark' : 'light');
      
      // Create observer for theme changes
      const observer = new MutationObserver(() => {
        const isDark = document.documentElement.classList.contains('dark');
        setColorScheme(isDark ? 'dark' : 'light');
      });
      
      // Start observing
      observer.observe(document.documentElement, { 
        attributes: true, 
        attributeFilter: ['class'] 
      });
      
      return () => observer.disconnect();
    }
  }, []);

  if (!mounted) return null;

  // Use the adapted LiveChat component with proper props
  return (
    <LiveChat 
      key={`live-chat-${colorScheme}`}
      mode="comprehensive"
      companyName="PAVISHA"
      assistantName="Package Assistant"
      position="bottom-right"
      primaryColor="red"
      secondaryColor="gold"
    />
  );
} 